export default __webpack_public_path__ + "static/vivawest-7f5957ea962390dbed48c4cdf116b60c.jpg";